import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { diffTrimmedLines } from 'diff';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { BaseUtenteComponent } from '../../../../../app/components/base-utente/base-utente.component';
import { GenEntityLogDto } from '../../../../../app/models/gestione/dto/gen-entity-log-dto';
import { EntityLogPars } from '../../../../../app/models/gestione/entity-log-pars';
import { AppManagerService } from '../../../../../app/services/app-manager.service';
import { DataService } from '../../../../../app/services/data.service';
import { GenLogService } from '../../../../../app/services/genlog.service';
import { Resources, TranslateService } from '../../../../../app/services/translate.service';
import { dateTimeFormatWithSec } from '../../../../../app/utils/util';
import { TranslateItemPipe } from '../../../../pipes/translate-item.pipe';

@Component({
  selector: 'app-entity-log',
  templateUrl: './entity-log.component.html',
  styles: ``,
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonModule,
    DatePipe,
    DialogModule,
    DividerModule,
    NgClass,
    NgFor,
    NgIf,
    NgSwitch,
    NgSwitchCase,
    NgTemplateOutlet,
    TranslateItemPipe
  ]
})
export class EntityLogComponent extends BaseUtenteComponent {
  T$: Observable<Resources> = this.translateService.translatedItems$(['generic.', 'entitylog.']);
  moadlEntityLog$: Observable<EntityLogPars>;
  entityLog$: Observable<GenEntityLogDto[]>;
  dateTimeFormatWithSec = dateTimeFormatWithSec;
  isExpandedView: boolean = false;
  visible: boolean = false;

  constructor(
    public override readonly appManagerService: AppManagerService,
    private readonly dataService: DataService,
    private readonly translateService: TranslateService,
    private readonly logService: GenLogService
  ) {
    super(appManagerService);
  }

  onUtenteInit(): void {
    this.moadlEntityLog$ = this.logService.getEntityLogSubject();

    this.entityLog$ = this.moadlEntityLog$.pipe(
      tap((data: EntityLogPars) => {
        this.visible = data.open;
        this.isExpandedView = false;
      }),
      filter((data: EntityLogPars) => data.open),
      switchMap((data: EntityLogPars) =>
        this.dataService.getGeneric(
          `${this.dataService.configSettings.restCommonUrl}/GetEntityLog`,
          `tableName=${data.tableName}&rowId=${data.rowId}`
        )
      ),
      map((data: GenEntityLogDto[]) => {
        return data.map((d) => {
          const diff = diffTrimmedLines(d.prevRowDb ?? '', d.rowDb ?? '');

          let span;

          const prevRowHtml = document.createElement('div');
          diff
            .filter((d) => !d.added)
            .forEach((part) => {
              span = document.createElement('span');
              if (part.removed) {
                span.className = 'hilight-log-text-removed';
              }
              span.appendChild(document.createTextNode(part.value));
              prevRowHtml.appendChild(span);
            });
          d['prevRowHtml'] = prevRowHtml;

          const rowHtml = document.createElement('div');
          diff
            .filter((d) => !d.removed)
            .forEach((part) => {
              span = document.createElement('span');
              if (part.added) {
                span.className = 'hilight-log-text-added';
              }
              span.appendChild(document.createTextNode(part.value));
              rowHtml.appendChild(span);
            });
          d['rowHtml'] = rowHtml;

          return d;
        });
      })
    );
  }

  hideModal(): void {
    this.logService.closeModalEntityLog();
  }
}
